import Grid from '@mui/material/Grid';
import { Box, IconButton, Modal, Paper, Stack, SvgIcon } from '@mui/material';
import { useMemo, useState } from 'react';


import 'dayjs/locale/de';
import PageHeader from '../../common/Components/PageHeader';
import { useParams } from 'react-router-dom';
import { useFetch } from '../../hooks/useFetch';
import PremMealInventorySummary from './PremMealInventorySummary';
import BoxHeader from '../../common/Components/BoxHeader';
import PremMealOrders from './PremMealOrders';
import PremMealImage from './PremMealImage';
import { ReactComponent as CloseIcon } from '../../icons/cross.svg';


function PremMealDetails() {
    const { id } = useParams();
    const { data = [] } = useFetch<any>(`/api/premmeal/${id}`);

    const [previewSrc, setPreviewSrc] = useState<string | undefined>(undefined);

    const title = useMemo(() => {
        return `${data.flightNumber ?? ''} ${data.dep ?? ''} - ${data.dest ?? ''} (${data.direction})`;
    }, [data])

    const files = data.files ?? [];

    const handleImageClick = (src: string) => {
        setPreviewSrc(src);
    };

    const handleClosePreview = () => {
        setPreviewSrc(undefined);
    };

    return (
        <Grid container spacing={3}>
            <Grid item xs={12}>
                <PageHeader title={title}>
                <Stack direction='row' spacing={2}> 
                   
                </Stack>
                    
                </PageHeader>
            </Grid>
            <Grid item xs={12} md={8}>
                <Paper sx={{ p: 2 }} elevation={3}>
                    <BoxHeader title='Orders'>
                                
                    </BoxHeader>
                    <Box>
                        <PremMealOrders item={data} />
                    </Box>
                </Paper>
            </Grid>
            <Grid item xs={12} md={4}>
                <Paper sx={{ p: 2 }} elevation={3}>
                    <BoxHeader title='Inventory Summary (Opening vs Closing)'>

                    </BoxHeader>
                    <Box>
                        <PremMealInventorySummary item={data} />
                    </Box>
                </Paper>
            </Grid>

            {files.length > 0 && (
                <Grid item xs={12}>
                    <Paper sx={{ p: 2 }} elevation={3}>
                        <BoxHeader title='Files' />
                        <Stack direction='row' spacing={2} sx={{ mt: 2, flexWrap: 'wrap', gap: 2 }}>
                            {files.map((f: any, idx: number) => (
                                <PremMealImage
                                    key={`${f.Url}-${idx}`}
                                    url={f.Url ?? ''}
                                    onClick={handleImageClick}
                                />
                            ))}
                        </Stack>
                    </Paper>
                </Grid>
            )}

            <Modal
                open={Boolean(previewSrc)}
                onClose={handleClosePreview}
                sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
            >
                <Box sx={{ position: 'relative', outline: 'none', maxWidth: '90vw', maxHeight: '90vh' }}>
                    <IconButton
                        onClick={handleClosePreview}
                        sx={{
                            position: 'absolute',
                            top: 8,
                            right: 8,
                            color: 'common.white',
                            backgroundColor: 'rgba(0, 0, 0, 0.5)',
                            '&:hover': { backgroundColor: 'rgba(0, 0, 0, 0.7)' },
                        }}
                    >
                        <SvgIcon component={CloseIcon} inheritViewBox />
                    </IconButton>
                    {previewSrc && (
                        <Box
                            component='img'
                            src={previewSrc}
                            alt='preview'
                            sx={{ maxWidth: '90vw', maxHeight: '90vh', display: 'block', borderRadius: 1 }}
                        />
                    )}
                </Box>
            </Modal>
        </Grid>
    );
}

export default PremMealDetails;